import React from "react";
import { Spinner } from "react-bootstrap";
import { p2e } from "../../Utils/functions";
import { useCheck } from "./Hooks";

const Login = () => {
  const { form, setForm, loading, check } = useCheck();
  return (
    <div className="login row">
      <div className="box col-md-4">
        <div className="display">
          <img
            style={{ width: "124px" }}
            src={require("../../Assets/images/logo.png")}
          />
        </div>

        <div>
          <div>
            <div className="font2">ورود / ثبت نام</div>
            <div className="font3">
              لطفا برای ورود شماره موبایل خود را وارد نمایید.
            </div>
          </div>
          <div>
            <input
              onChange={({ target: { value } }) => {
                setForm({ ...form, mobile: p2e(value) });
              }}
              autoFocus={true}
              onKeyDown={e => {
                if (e.key === "Enter") {
                  check();
                }
              }}
            />
          </div>
          <button
            onClick={check}
            className="primary-btn"
            style={{ fontSize: "15px" }}
          >
            {loading ? <Spinner size="sm" /> : "ورود"}
          </button>
          <div className="font4">
            ورود شما به معنای قبول <a href="">شرایط صنعتبان</a> و{" "}
            <a href="">قوانین حریم خصوصی</a> می باشد.
          </div>
        </div>

        <div>
          <div className="font1">نیازمندی های رایگان صنعت</div>
          <div className="font1" style={{ color: "#888888", marginTop: "5px" }}>
            تلفن پشتیبانی: 02191027127
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
